import React from 'react'
import { Route, Routes } from 'react-router-dom'
import OrdersListPage from '../orders/presentation/components/pages/OrdersListPage/OrdersListPage'
import ShowOrderPage from '../components/pages/ShowOrderPage/ShowOrderPage'
import ShowOrderDetailsPage from '../orders/presentation/components/pages/ShowOrderDetailsPage/ShowOrderDetailsPage'
import { CreateOrdersNoTemplate } from '../components/pages/CreateOrdersNoTemplate/CreateOrdersNoTemplate'
import { CreateOrdersTemplate } from '../components/pages/CreateOrdersTemplate/CreateOrdersTemplate'

const OrderRoutes = () => {
    return (
        <Routes>
            <Route index element={<OrdersListPage />} />
            <Route
                path="create/no-template"
                element={<CreateOrdersNoTemplate />}
            />
            <Route path="create/template" element={<CreateOrdersTemplate />} />
            <Route
                path="show/details/:orderId"
                element={<ShowOrderDetailsPage />}
            />
            <Route path="show/:orderId" element={<ShowOrderPage />} />
        </Routes>
    )
}

export default OrderRoutes
